import React from "react";
import {styled} from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Header from "./Header";
import MuiAppBar, {AppBarProps as MuiAppBarProps} from "@mui/material/AppBar";

interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
    sideMenuDrawerWidth: number;
    // miniSideMenuDrawerWidth: number;
}

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) =>
        prop !== "open" && prop !== "sideMenuDrawerWidth",
})<AppBarProps>(({theme, open, sideMenuDrawerWidth}) => ({
    zIndex: theme.zIndex.drawer + 1,
    // width: `calc(100% - ${miniSideMenuDrawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: sideMenuDrawerWidth,

        // width: `calc(100% - ${sideMenuDrawerWidth}px)`,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

interface TopBarProps {
    open?: boolean;
    sideMenuDrawerWidth: number;
    miniSideMenuDrawerWidth: number;
    appBarAltezza: number;
    logoPiccolo: any;
    tooggleDrawer: () => void;
}

export default function TopBar({
                                   open,
                                   sideMenuDrawerWidth,
                                   miniSideMenuDrawerWidth,
                                   appBarAltezza,
                                   logoPiccolo,
                                   tooggleDrawer,
                               }: TopBarProps) {
    return (
        <AppBar
            position="fixed"
            open={open}
            sideMenuDrawerWidth={sideMenuDrawerWidth}
            sx={{
                height: miniSideMenuDrawerWidth,
                px: 0,
                width: {
                    xs: open ? `calc(100% - ${sideMenuDrawerWidth}px)` : `100%`,
                    // sm: open
                    // 	? `calc(100% - ${sideMenuDrawerWidth}px)`
                    // 	: `calc(100% - ${miniSideMenuDrawerWidth}px)`,
                    background:'#FFF'
                },
                minHeight: appBarAltezza,
                py: 0,
            }}
        >
            <Toolbar sx={{pr: 0, pl: 0}}>
                <IconButton
                    // color="white"
                    aria-label="open drawer"
                    onClick={tooggleDrawer}
                    edge="start"
                    sx={{
                        mr: 2,
                        pl: 0,
                        // ...(open && { display: "none" }),
                        color: "#0081c1",
                    }}
                    size="large"
                >
                    <img
                        src={logoPiccolo}
                        alt="GI"
                        style={{
                            height: miniSideMenuDrawerWidth,
                            // paddingTop: 15,
                            // paddingBottom: 15,
                            paddingLeft: 0,
                            // paddingRight: 25,
                        }}
                    />
                </IconButton>

                {/*<Typography*/}
                {/*    variant="h4"*/}
                {/*    noWrap*/}
                {/*    component="div"*/}
                {/*    display="inline"*/}
                {/*    color="theme.palette.text.primary"*/}
                {/*>*/}
                {/*    {"EVOP: Everest Ordini e Produzione"}*/}
                {/*</Typography>*/}
                {process.env.NODE_ENV != "production" && (
                    <Typography variant="h6" color="red" noWrap display="inline" sx={{ml: 2}}>
                        {process.env.NODE_ENV}
                    </Typography>
                )}
                <Box
                    sx={{
                        display: "flex",
                        flex: 1,
                        justifyContent: "flex-end",
                    }}
                >
                    <Header/>
                </Box>
            </Toolbar>
        </AppBar>
    );
}
